import { render, staticRenderFns } from "./BindUsdt.vue?vue&type=template&id=27c0e119&scoped=true"
import script from "./BindUsdt.vue?vue&type=script&lang=js"
export * from "./BindUsdt.vue?vue&type=script&lang=js"
import style0 from "./BindUsdt.vue?vue&type=style&index=0&id=27c0e119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0e119",
  null
  
)

export default component.exports